import { api } from "@/lib/api";

const SECTIONS = ["learn", "how", "about", "booking"];
const state = { sid: null, active: 0, scroll: 0, sections: new Set(), started: false };

const uid = () => {
  try {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
  } catch (e) {
    // fall through
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
};

const store = (s) => {
  try {
    const k = "__fad_t";
    s.setItem(k, "1");
    s.removeItem(k);
    return s;
  } catch (e) {
    return null;
  }
};

function getOrSet(s, key) {
  let v = s && s.getItem(key);
  if (!v) {
    v = uid();
    if (s) s.setItem(key, v);
  }
  return v;
}

function ids() {
  return { vid: getOrSet(store(window.localStorage), "fad_vid"), sid: getOrSet(store(window.sessionStorage), "fad_sid") };
}

const payload = (event) => ({ session_id: state.sid, active_seconds: state.active, max_scroll: state.scroll, sections: [...state.sections], event });

function beacon() {
  try {
    const url = `${api.defaults.baseURL}/track/ping`;
    const blob = new Blob([JSON.stringify(payload())], { type: "application/json" });
    if (!navigator.sendBeacon?.(url, blob)) api.post("/track/ping", payload()).catch(() => {});
  } catch (e) {
    // ignore
  }
}

export function trackEvent(event) {
  if (state.started) api.post("/track/ping", payload(event)).catch(() => {});
}

export function startTracking() {
  try {
    return start();
  } catch (e) {
    return () => {};
  }
}

function start() {
  if (state.started || store(window.localStorage)?.getItem("fad_admin") === "1") return () => {};
  const { vid, sid } = ids();
  Object.assign(state, { sid, started: true });
  const q = new URLSearchParams(window.location.search);
  api.post("/track/start", {
    session_id: sid, visitor_id: vid, path: window.location.pathname, referrer: document.referrer || null,
    utm_source: q.get("utm_source"), utm_campaign: q.get("utm_campaign"),
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone, language: navigator.language,
    screen: `${window.screen.width}x${window.screen.height}`,
  }).catch(() => {});

  const tick = setInterval(() => {
    if (document.visibilityState === "visible") state.active += 1;
  }, 1000);
  const ping = setInterval(() => {
    if (document.visibilityState === "visible") api.post("/track/ping", payload()).catch(() => {});
  }, 15000);
  const onScroll = () => {
    const h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0) state.scroll = Math.max(state.scroll, Math.min(100, Math.round((window.scrollY / h) * 100)));
  };
  const onHide = () => {
    if (document.visibilityState === "hidden") beacon();
  };
  const io = "IntersectionObserver" in window ? new IntersectionObserver((entries) => {
    entries.forEach((e) => e.isIntersecting && state.sections.add(e.target.id));
  }, { threshold: 0.3 }) : null;
  SECTIONS.forEach((id) => {
    const el = document.getElementById(id);
    if (el && io) io.observe(el);
  });
  window.addEventListener("scroll", onScroll, { passive: true });
  document.addEventListener("visibilitychange", onHide);
  window.addEventListener("pagehide", beacon);

  return () => {
    clearInterval(tick);
    clearInterval(ping);
    io?.disconnect();
    window.removeEventListener("scroll", onScroll);
    document.removeEventListener("visibilitychange", onHide);
    window.removeEventListener("pagehide", beacon);
    beacon();
    state.started = false;
  };
}
